import type { FC } from 'react';
import { CopyButton } from '@/components/CopyButton/CopyButton';
import React from 'react';
import { Flex, Text, useMantineTheme } from '@mantine/core';
import classes from './Insight.module.css';

interface Props {
  /**
   * Insight name
   */
  name: string;
  /**
   * Insight data
   */
  data?: string;
  children?: React.ReactNode;
  tooltip?: React.ReactNode;
  googleEvent?: string;
  withCopy?: boolean;
  externalMenu?: React.ReactNode;
  /**
   * Test ID for the insight container
   */
  'data-testid'?: string;
}

export const Insight: FC<Props> = ({
  name,
  data,
  tooltip,
  googleEvent,
  withCopy = false,
  externalMenu,
  'data-testid': testId,
  ...props
}) => {
  const theme = useMantineTheme();

  return (
    <Flex justify="space-between" align="center" gap={8} data-testid={testId}>
      <Flex className={classes.title} gap={4}>
        <Text size={theme.other.typography.size.sm}>{name}</Text>
        {tooltip}
      </Flex>
      {data && (
        <Flex align="center" className={classes.content} gap={8}>
          <Text
            lh={theme.other.typography.lineHeight.md}
            size={theme.other.typography.size.sm}
            className={classes.data}
            ta="right"
            fw={theme.other.typography.weight.medium}
            data-testid={testId ? `${testId}-value` : undefined}
            style={{
              overflowWrap: 'anywhere', // Break on even extremely long, unbreakable strings
            }}
          >
            {data}
          </Text>
          <Flex>
            {withCopy && (
              <CopyButton name={name} data={data} googleEvent={googleEvent} />
            )}
            {externalMenu && externalMenu}
          </Flex>
        </Flex>
      )}
      {props.children}
    </Flex>
  );
};
